<div class="ddr-main-container">
    <!-- Dialog Header -->
    <div class="ddr-header-row">
      <div class="ddr-header-content">
        <span class="ddr-title">Due date and reminders</span>
        <owc-switch
          [(ngModel)]="DueDateEnabled"
          [disabled]="!feedbackEnabled"
          (change)="updateEnabled($event)"
        >
          Enabled
        </owc-switch>
      </div>
      <owc-icon name="clear" family="outlined" class="ddr-close-button" (click)="cancelAndClose()"></owc-icon>
    </div>

    <!-- Content when disabled -->
    <div *ngIf="!DueDateEnabled" class="ddr-disabled-content">
      <div class="ddr-disabled-info">
        The notification will not have a due date and will never be overdue.
      </div>
      
      <!-- Footer when disabled -->
      <div class="ddr-footer-actions">
        <owc-button variant="primary" (click)="saveAndClose()" [disabled]="!feedbackEnabled">
          Save
        </owc-button>
      </div>
    </div>

    <!-- Content when enabled -->
    <div *ngIf="DueDateEnabled" class="ddr-enabled-content">
      <!-- Due date section -->
      <div class="ddr-duedate-section">
        <h4>Due date</h4>
        <p>Set the date, by which the customer should provide feedback the latest:</p>

        <div style="display: flex; align-items: center; gap: 12px;">
          <owc-datepicker
            size="small"
            label="Feedback due date"
            variant="outlined"
            format="dd-MMM-yyyy"
            [disabledDates]="feedbackDueDateFilter"
            [formControl]="feedbackDueDate"
            (valueChange)="getFeedbackDueDate(feedbackDueDate.value)"
          >
          </owc-datepicker>
          <owc-button 
            *ngIf="showDueDateSaveButton" 
            variant="primary" 
            size="small"
            (click)="saveDueDateChange()"
          >
            Save
          </owc-button>
        </div>
      </div>

      <!-- Reminder section -->
      <div class="ddr-reminder-section">
        <h4>Reminder(s)</h4>
        <p>Click on "Add reminder" to add the reminder(s) you want to send to the customer.</p>

        <div class="ddr-reminder-table-container" *ngIf="remindersData.length > 0">
          <dl-reminder-table-popup
            [displayedColumns]="remindersColumn"
            [tableData]="remindersData"
            [addMoreReminder]="addMoreReminders"
            [notificationData]="notificationData"
            [feedbackDueDate]="feedbackDueDate.value"
            (tableDataChange)="onTableDataChange($event)"
          ></dl-reminder-table-popup>
        </div>

        <!-- Footer with Add Reminder and Close -->
        <div class="ddr-footer-actions">
          <owc-button
            (click)="openReminderTemplateDialog()"
            [disabled]="!feedbackDueDate.value || feedbackDueDate.invalid"
            class="btn-add-reminder"
            variant="secondary"
          >
            Add Reminder
          </owc-button>
          <owc-button variant="primary" (click)="closePopup()">
            Close
          </owc-button>
        </div>

        <owc-modal-dialog #modalDialogElement [(ngModel)]="reminderVisible" size="medium">
          <dl-reminder-message-templete-dialog-popup
            *ngIf="reminderVisible"
            [data]="data"
            (dialogClose)="onReminderDialogClose($event)"
          ></dl-reminder-message-templete-dialog-popup>
        </owc-modal-dialog>
      </div>
    </div>
  </div>
  